import { render, staticRenderFns } from "./AutoPlayer.vue?vue&type=template&id=0ab91663&scoped=true"
import script from "./AutoPlayer.vue?vue&type=script&lang=js"
export * from "./AutoPlayer.vue?vue&type=script&lang=js"
import style0 from "./AutoPlayer.vue?vue&type=style&index=0&id=0ab91663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab91663",
  null
  
)

export default component.exports